<template>
  <nav class="navbar navbar-expand-lg border-0">
    <div class="container-fluid mt-3 mb-0">
      <div></div>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a
              class="nav-link text-danger d-flex align-items-center"
              style="cursor: pointer"
              @click.prevent="logout()"
            >
              Salir<i class="bi bi-door-open-fill ml-1"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  computed: {
    routeName() {
      const { name } = this.$route
      return this.capitalizeFirstLetter(name)
    }
  },
  methods: {
    ...mapActions(['logout']),
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
  }
}
</script>
